import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { Redirect, withRouter } from "react-router-dom";
import {
  userLoginWithOTP,
  // userLoginGenerateOTP,
  userLoginGenerateOTPClear,
  userLoginRequest
} from "../../actions/login.action";
import {
  getProjectList,
  getPermissionsAction
} from "../../actions/common.action";
import { ERROR_MSG, PATHS } from "../../constant";
import { getLocalstorage } from "../../helper";
import { PHONE_VALIDATE, EMAIL_VALIDATE, OTP_LENGTH } from "../../validation";
import { Form, Button } from "react-bootstrap";
import { LoaderPage } from "../../component/Loader";
import { sendSignUpOtp } from "../../actions/signup.action";
import { toast } from "react-toastify";
import { get } from "lodash";
import ReCaptcha from "../GoogleCaptcha/googleCaptcha";
import TooltipComponent from "../../component/TooltipComponent";
import OtpInput from "react-otp-input";
import { successToastStyle, errorToastStyle } from "../../customToast";
class LoginFormOtp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      mobileNumber: "",
      otp: "",
      redirectToReferrer: !!getLocalstorage("token"),
      sendOTPEnable: true,
      count: 1,
      isEmail: false,
      disabledOtp: true
    };
  }

  componentDidMount() {
    this.disableOtp();
  }

  handleGenerateOtp = async value => {
    let { errors, count, disabledOtp } = this.state;
    let { userLoginRequest } = this.props;
    const userId = getLocalstorage("userId");

    if (disabledOtp) {
      return;
    }

    const payload = {
      loginType: "OTP",
      userId: userId
    };
    this.setState({ count: count + 1, disabledOtp: true });
    this.disableOtp();
    let otpResult = await userLoginRequest(payload);
    if (get(otpResult, "status")) {
      this.setState({
        //showEnterOtp: true,
        disabledOtp: true
      });
      toast.success(
        <p className="toast-text-alignment">{get(otpResult, "message")}</p>,
        successToastStyle
      );
    } else if (!get(otpResult, "status")) {
      this.setState({ disabledOtp: false });
      toast.error(
        <p className="toast-text-alignment">{get(otpResult, "message")}</p>,
        errorToastStyle
      );
    }
  };

  handleChange = event => {
    const { name, value } = event.target;
    const params = {};
    if (name === "mobileNumber") {
      const regex = new RegExp(/^([0-9]+)$/);
      if (regex.test(value)) {
        params.isEmail = false;
      } else {
        params.isEmail = true;
      }
    }

    this.setState({ [name]: value, ...params }, () => {
      name === "mobileNumber" && this.validateField("mobileNumber", value);
    });
  };

  handleOtp = (name, otp) => {
    this.setState({ [name]: otp, isWrongOtp: false });
  };

  validateField = (fieldName, value) => {
    let { errors, mobileNumber, otp, isEmail } = this.state;
    // const { userLoginGenerateOTP } = this.props;
    switch (fieldName) {
      case "mobileNumber":
        if (!isEmail) {
          errors.phoneValid = PHONE_VALIDATE(value);
          errors.phoneValid = {
            ...errors.phoneValid,
            message: !value
              ? "Please enter valid email or mobile number"
              : errors.phoneValid.message
          };
          if (errors.phoneValid.error === false) {
            this.setState({ sendOTPEnable: true });
          } else {
            this.setState({ sendOTPEnable: false });
          }
        } else {
          errors.phoneValid = EMAIL_VALIDATE(value);
          errors.phoneValid = {
            ...errors.phoneValid,
            message: !value
              ? "Please enter valid email or mobile number"
              : errors.phoneValid.message
          };
          if (errors.phoneValid.error === false) {
            this.setState({ sendOTPEnable: true });
          } else {
            this.setState({ sendOTPEnable: false });
          }
        }
        break;

      case "otp":
        errors.otpValid = OTP_LENGTH(value);
        break;
      default:
        errors.phoneValid = isEmail
          ? EMAIL_VALIDATE(mobileNumber)
          : PHONE_VALIDATE(mobileNumber);
        errors.otpValid = OTP_LENGTH(otp);
        break;
    }
    this.setState({
      errors: errors
    });
  };

  validateForm = () => {
    let { errors } = this.state;
    let { otpValid } = errors;
    return otpValid.error !== undefined && !otpValid.error;
  };

  submitLoginForm = async () => {
    const { otp, captchaToken } = this.state;
    const { userLoginWithOTP, getPermissionsDispatch } = this.props;
    const userId = getLocalstorage("userId");
    this.validateField("otp", otp);
    await userLoginWithOTP(undefined, {
      otp: otp,
      userId: userId,
      googleCaptchaToken: captchaToken
    });
    this.captchaElement &&
      this.captchaElement.reset(this.captchaElementResetId);
    const { loginResult, history } = this.props;
    if (get(loginResult, "status")) {
      getPermissionsDispatch();
      if (!get(loginResult, "data.user.projectCreatedBy")) {
        history.push(PATHS.CREATE_PROJECT);
      } else {
        history.push(PATHS.DASHBOARD);
      }

      toast.success(
        <p className="toast-text-alignment">{loginResult.message}</p>,
        successToastStyle
      );
    } else {
      toast.error(
        <p className="toast-text-alignment">OTP is invalid</p>,
        errorToastStyle
      );
      history.push(PATHS.LOGIN);
    }
  };

  onCaptchaResolved = captchaToken => {
    this.setState({ captchaToken });
    (captchaToken && this.submitLoginForm()) ||
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_CAPTCHA}</p>,
        errorToastStyle
      );
  };

  onValidateCaptcha = e => {
    e.preventDefault();
    this.validateField();
    let isValidData = this.validateForm();
    if (isValidData && this.captchaElement) {
      this.captchaElement.execute();
    }
  };

  // keep otp send of
  disableOtp = () => {
    setTimeout(() => {
      this.setState({
        disabledOtp: false
      });
    }, 30000);
  };

  render() {
    const {
      mobileNumber,
      otp,
      errors,
      redirectToReferrer,
      sendOTPEnable,
      count,
      disabledOtp
    } = this.state;
    const {
      handleLoginWithPassword,
      location,
      loading,
      otpStatus,
      loginRequestData
    } = this.props;
    const { from } = location.state || { from: { pathname: PATHS.DASHBOARD } };
    if (redirectToReferrer) return <Redirect to={from} />;
    if (loginRequestData && !loginRequestData.status)
      return <Redirect to={PATHS.LOGIN} />;
    return (
      <div className="register-inner">
        <LoaderPage
          loading={loading === "LOADING" || otpStatus === "LOADING"}
        />
        <h1 className="page-heading hide-heading">Login</h1>
        <p className="page-sub-heading first-sub-heading">
          Hi, {loginRequestData.data}
        </p>
        <p className="page-sub-heading second-sub-heading">
          OTP has been sent on your registered mobile number
        </p>
        <Form className="signin-form" onSubmit={this.onValidateCaptcha}>
          {
            <Form.Group controlId="password">
              <Form.Label>OTP</Form.Label>
              <div className="otp-wrapper-box">
                <span
                  className={`${
                    !sendOTPEnable ? "disabled-otp" : "forgetLink"
                  } ${(disabledOtp && "otpDisabled") || ""}`}
                  onClick={this.handleGenerateOtp}
                >
                  {count > 0 ? (
                    <span>
                      Resend OTP{" "}
                      {disabledOtp ? (
                        <TooltipComponent
                          classes="info-icon"
                          placement="right"
                          content={
                            <>
                              If you didn't receive the OTP, please try again
                              after 30 seconds.
                            </>
                          }
                        />
                      ) : (
                        ""
                      )}
                    </span>
                  ) : null}
                </span>
                {/* <Form.Control
                type="text"
                name="otp"
                value={otp}
                maxLength="4"
                onChange={this.handleChange}
                onBlur={() => this.validateField("otp", otp)}
                isInvalid={errors.otpValid && errors.otpValid.error}
              />
              <Form.Control.Feedback type="invalid">
                {errors.otpValid && errors.otpValid.error
                  ? errors.otpValid.message
                  : null}
              </Form.Control.Feedback>*/}

                <OtpInput
                  containerStyle="otp-code"
                  onChange={otp => this.handleOtp("otp", otp)}
                />
              </div>
              <div className="invalid-feedback">
                {errors.otpValid && errors.otpValid.error
                  ? errors.otpValid.message
                  : null}
              </div>
            </Form.Group>
          }

          <ReCaptcha
            id="recaptcha-1"
            getRef={ref => {
              this.captchaElement = ref;
            }}
            onChange={this.onCaptchaResolved}
            resetId={id => {
              this.captchaElementResetId = id;
            }}
          />

          <Button
            variant="primary"
            type="submit"
            className="btn-orange full-width"
          >
            Login
          </Button>
        </Form>
      </div>
    );
  }
}

LoginFormOtp.propTypes = {
  history: PropTypes.shape({})
};

LoginFormOtp.defaultProps = {
  history: {}
};

function mapStateToProps(state) {
  return {
    loginResult: state.loginReducer.data,
    loading: state.loginReducer.loginStatus,
    otpStatus: state.loginReducer.otpStatus,
    otpData: state.loginReducer.otpData,
    loginRequestData: state.loginReducer.loginRequestData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      userLoginWithOTP: userLoginWithOTP,
      // userLoginGenerateOTP: userLoginGenerateOTP,
      userLoginGenerateOTPClear: userLoginGenerateOTPClear,
      sendSignUpOtp: sendSignUpOtp,
      getProjectList: getProjectList,
      getPermissionsDispatch: getPermissionsAction,
      userLoginRequest
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoginFormOtp)
);
